<section class="contenedorValidacion">
  <a  href={{url}} target="_blank">
  <img
    class="imgDocument"
    src="../../../../assets/images-document-preview@3x.png"
    alt=""
  />
</a>

  <div class="validacion">
    <div *ngIf="path === '/inproeco/estado/pendientes'; else elseBlock">
      <h2>Validacion de Documentos</h2>
    </div>
    <ng-template #elseBlock><h2>Detalle de Documentos</h2></ng-template>
    <table class="tablaDetalles">
      <tr>
        <td class="data">Documento</td>
        <td class="descripcion">
          {{ documento?.nombre }}
        </td>
      </tr>
      <tr>
        <td class="data">Fecha Validez</td>
        <td class="descripcion">
          {{ documento?.fechaValidez | date: 'dd/MM/yyyy' }}
        </td>
      </tr>
      <tr>
        <td class="data">Fecha Caducidad</td>
        <td class="descripcion">
          <ng-container *ngIf="!documento?.noCaduca">
            {{ documento?.fechaCaducidad | date: 'dd/MM/yyyy' }}
          </ng-container>
          
          <ng-container *ngIf="documento?.noCaduca">
            No caduca
          </ng-container>
          
        </td>
      </tr>
      <tr>
        <td class="data">Fecha de subida</td>
        <td class="descripcion">
          {{ documento?.createdAt | date: 'dd/MM/yyyy' }}
        </td>
      </tr>
    </table>
    <div *ngIf="path === '/inproeco/estado/pendientes'">
      <button
        class="boton__siguiente"
        (click)="updateValidacionDocumentoById()"
        [mat-dialog-close]
      >
        Validar
      </button>
    </div>
  </div>
  <div class="notificaciones">
    <form [formGroup]="notificaciones">
      <h2>Notificaciones</h2>
      <mat-form-field appearance="outline" class="dropdown">
        <mat-select
          placeholder="Causa de la notificación"
          formControlName="causa"
          class="selector__motivo"
        >
          <div *ngFor="let causa of causasNotificacion">
            <mat-option value="{{ causa }}">
              {{ causa }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
      <p class="descripcion">Añadir Comentarios</p>
      <textarea rows="4" cols="50" formControlName="comentario"></textarea>
      <button
        class="button__secondary"
        (click)="updateComentarios(); updateDocumentoNoValidadoById() "
        [mat-dialog-close]
      >
        <img src="../../../../assets/icons-notificar@3x.png" />
        Notificar
      </button>
    </form>
  </div>
<!--  <div *ngIf="!documento?.seguridadSocial && !documento?.hacienda">
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios displayFlexColumn">
      <div *ngFor="let comentario of comentarios" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">
          {{ comentario.causa }}
        </div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>  -->
  <div>
    <div *ngIf="documento?.seguridadSocial">
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios1 displayFlexColumn">
      <div *ngFor="let comentario of comentariosSeguridadSocial" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">{{ comentario.causa }}</div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="documento?.hacienda">
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios1 displayFlexColumn">
      <div *ngFor="let comentario of comentariosHacienda" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">{{ comentario.causa }}</div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="documento?.gestor">
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios1 displayFlexColumn">
      <div *ngFor="let comentario of comentarios1" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">{{ comentario.causa }}</div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="documento?.transportista">
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios1 displayFlexColumn">
      <div *ngFor="let comentario of comentarios2" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">{{ comentario.causa }}</div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="documento?.centro">
    <h2 class="titulo-coment">Comentarios</h2>
    <div class="comentarios1 displayFlexColumn">
      <div *ngFor="let comentario of comentarios3" class="displayFlexColumn">
        <div class="fecha-coment">
          {{ comentario.fecha | date: 'dd/MM/yyyy' }}
        </div>
        <div class="fecha-coment">{{ comentario.causa }}</div>
        <div class="comentario">{{ comentario.comentario }}</div>
      </div>
    </div>
  </div>


</div>


</section>
